<template>
  <div class="h-100"
    v-loading="loading"
    element-loading-text="Loading..."
    element-loading-spinner="el-icon-loading"
  >
    <iframe
      v-if="isConversationId"
      class="framePreview"
      :src="conversationDetailUrl"
      width="100%"
      height="650"
    ></iframe>
    <div class="pa-5 wr-body" style="max-height: calc(80vh- 102px);overflow-y: scroll;" v-if="conversationList.length > 0">
      <ZaloConversationItem
        v-for="(conversation, index) in conversationList"
        :conversation="conversation"
        :accountList="accountList"
        :key="index"
      />
    </div>
    <div class="h-100 d-flex flex-grow-1 align-items-center justify-content-center" v-else>
      <span class="text-subtitle-1">Chưa có thông tin hội thoại</span>
    </div>
  </div>
</template>

<script>
import { HTTP } from "@/lib/http-common";
import ZaloConversationItem from "./ZaloConversationItem.vue";

export default {
  components : {
    ZaloConversationItem
  },
  data() {
    return{
      conversationList : [],
      accountList : [],
      loading : true,
    }
  },
  props : {
    contact : {
      type : Object,
      require : true,
    }
  },
  computed : {
    isConversationId() {
      const pattern = /^\d+_\d+_\d+_\d+$/;
      return pattern.test(this.contact.phone);
    },
    conversationDetailUrl() {
      return `https://zalo.salework.net/conversation?id=${this.contact.phone}`;
    }
  },
  methods: {
    async fetchConversationZalo(){
      this.loading = true;
      if (this.isConversationId) {
        this.loading = false;
        return; // bỏ qua gọi API
      }
      const res = await HTTP.post(`api/contact/search-zalo?phone=${this.contact.phone}`);
      if (res && res.data) {
        this.conversationList = res.data.conversation;
        if(Object.keys(res.data).length === 0){
          this.loading = false;
          this.conversationList = []
        }else{
          this.conversationList = res.data.conversation;
          this.loading = false
        }
      }
    },
    async getAllAccount(){
      const res = await HTTP.get(`api/contact/account-zalo`);
      if (res && res.data) {
        this.accountList = res.data.accounts;
      }
    }
  },
  created(){
    this.fetchConversationZalo();
    this.getAllAccount();
  }
};
</script>

<style>
.wr-body{
  height: calc(80vh - 102px)!important;
}
</style>